import {
  MaterializedProcessDocument,
  StepStarterDocument,
  StepStarterMutation,
  StepStarterMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useStepStarter = () => {
  const [StepStarter, { loading }] = useMutation(StepStarterDocument, {
    extractorFn: (data: StepStarterMutation) => data.processesMutations.startProcessesStartStep,
  })

  return {
    loading,
    async stepStarter(variables: StepStarterMutationVariables) {
      await StepStarter({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: MaterializedProcessDocument,
            variables: {
              id: variables.materializedProcessId,
            },
          },
        ],
      })
    },
  }
}
